import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const ContactsInbox = () => {
  const [contacts, setContacts] = useState(null);

  useEffect(() => {
    api.get("/admin/contacts")
      .then((res) => setContacts(res.data))
      .catch(() => toast.error("Errore nel caricamento delle richieste"));
  }, []);

  if (!contacts) return <p className="text-xs font-mono tracking-[0.25em] text-fog">CARICAMENTO…</p>;

  return (
    <div data-testid="admin-contacts-page">
      <h1 className="text-2xl font-normal tracking-tight text-bone">Richieste di contatto</h1>
      <p className="mt-1 text-sm text-fog">I messaggi inviati dal form contatti del sito.</p>

      {contacts.length === 0 && (
        <p data-testid="contacts-empty" className="mt-10 text-sm text-fog">Nessuna richiesta per ora.</p>
      )}

      <div className="mt-8 space-y-4">
        {contacts.map((contact) => (
          <div key={contact.id} data-testid={`contact-row-${contact.id}`} className="border border-line bg-surface p-5">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="text-sm font-medium text-bone">{contact.name} <span className="text-fog font-normal">— {contact.email}</span></p>
              <p className="text-[10px] font-mono tracking-[0.15em] text-fog">{new Date(contact.created_at).toLocaleString("it-IT")}</p>
            </div>
            <p className="mt-1 text-[10px] font-mono tracking-[0.2em] text-gold uppercase">
              {contact.project_type || "—"}{contact.company ? ` · ${contact.company}` : ""}
            </p>
            <p className="mt-3 text-sm text-fog leading-relaxed whitespace-pre-wrap">{contact.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactsInbox;
